// src/services/productService.js

import { http } from "../../lib/http";
import { getUser } from "../../lib/authToken";
import { DEV_USER } from "../../config/localAuth";

/**
 * Resolve restaurant id from param OR logged-in user
 */
function resolveRestaurantId(restaurantId) {
  if (restaurantId) return restaurantId;

  const user = getUser() || DEV_USER;

  if (user?.restaurant_id) {
    return user.restaurant_id;
  }

  throw new Error("Restaurant ID not found");
}

/**
 * Fetch products for a restaurant
 */
export async function getProducts(restaurantId) {
  const restId = resolveRestaurantId(restaurantId);

  try {
    const response = await http.get(`/web/restaurants/${restId}/products`, {
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
      },

      // withCredentials: true, // ✅ send cookies
    });

    console.log("===== PRODUCTS API RESPONSE =====");
    console.log("Status:", response.status);
    console.log("Headers:", response.headers);
    console.log("Data:", response.data);
    console.log("=================================");

    console.log("response", response);

    // ✅ Axios automatically parses JSON
    // return response.data;
    return response;
  } catch (error) {
    console.log("===== PRODUCTS API ERROR =====");
    console.log("Error Message:", error.message);
    console.log("Error Status:", error.response?.status);
    console.log("Error Data:", error.response?.data);
    console.log("=================================");

    console.error("getProducts API Error:", error);

    if (error.response?.status === 401) {
      throw new Error("Session expired. Please login again.");
    }

    throw new Error("Failed to fetch products.");
  }
}

/**
 * Create Payment
 */
export async function createPayment(payload) {
  console.log("🚀 createPayment called");

  console.log("Sending Payload:", payload);
  try {
    const response = await http.post("/web/generate-payment", payload, {
      withCredentials: true,
    });

    console.log("API RESPONSE:", response);

    return response;
  } catch (error) {
    console.error("SERVICE ERROR:", error);
    throw error;
  }
}


export async function getSessionInfo() {
  const res = await http.get("/web/me", {
    withCredentials: true, // 🔥 VERY IMPORTANT
  });

  return res; // { session_id: "xxxx" }
}